import ListIncomePage from "./ListIncomePage";

export default ListIncomePage;
